// Módulos que puede abrir un Piloto (según sus categorías / permisos individuales).
export const APPS_PILOTO = [
  ["domicilios", "/domicilios", "App Domicilios"],
  ["colocacion", "/app-colocacion", "Recolección y Colocación"],
  ["empaque", "/app-empaque", "App Empaque"],
  ["organizador", "/organizador-paquetes", "Organizador de Paquetes"],
  ["seguimiento", "/app-seguimiento", "Seguimiento y Entregas"],
  ["entregas", "/mis-entregas", "Mis entregas"],
  ["reportes", "/reporte-ruta", "Reporte de Ruta"],
  ["cuadre", "/cuadre-repartidor", "Cuadre de repartidor"],
  ["marcaje", "/marcaje", "Marcaje"],
  ["pedidos", "/pedidos", "Hoja de Pedidos"],
  ["dashboard", "/panel", "Dashboard"],
];

export const modulosPiloto = (user) => {
  const m = user?.modulos;
  if (!user?.modulos_custom || !Array.isArray(m) || m.length === 0) return APPS_PILOTO.filter(([k]) => k === "domicilios");
  return APPS_PILOTO.filter(([k]) => m.includes(k));
};

export const inicioPiloto = (user) => {
  const l = modulosPiloto(user);
  if (l.length === 1) return l[0][1];
  return l.length ? "/mis-apps" : "/login";
};

export const inicioDe = (user) => (user?.role === "piloto" ? inicioPiloto(user) : "/panel");
